import { AnswerCommand } from 'core/commands/elements/answers/answer.abstract.command';
import { tactileoAnswersDTOTypes } from 'utils/activityItem.util';

export class AssociateQuestionAnswerCommand extends AnswerCommand {
  constructor(associateQuestion) {
    super(tactileoAnswersDTOTypes.ASSOCIATE_QUESTION, associateQuestion);
    this.r_ids = associateQuestion.rIds;
  }
}
